import { Validators } from "@angular/forms";
import { BasespaceFormControl, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchTextAreaControlComponent } from "./bs-app-launch-text-area-control.component";

export interface TextAreaFormControlProperties extends BasespaceFormProperties<BsAppLaunchTextAreaControlComponent> {
    maxLength?: string;
    height?: number;
}

// Reference class: src/Cloud.FormBuilder/Models/TextArea.cs
export class TextAreaFormControl extends BasespaceFormControl<BsAppLaunchTextAreaControlComponent> implements TextAreaFormControlProperties {
    maxLength?: string;
    height?: number;

    constructor(
        data: TextAreaFormControlProperties
    ) {
        const { 
            id, 
            componentReference, 
            label, 
            maxLength, 
            height, 
            helpText, 
            size,
            value, 
            required, 
            requiredMessage, 
            tabularFieldSetStyling,
            formControlType
        } = data;

        super({ 
            id, 
            componentReference, 
            label, 
            helpText, 
            size,
            value, 
            required, 
            requiredMessage, 
            tabularFieldSetStyling,
            formControlType
        });

        // Using defaults from dev portal
        this.maxLength = maxLength ? maxLength.toString() : '500';

        // Weird scenario where "width" instead of "size" used for field width
        this.size = data['width'];
        this.height = height || 50;
    
        if(required) {
            this.setValidators(Validators.required);
        }
    
        this.setValue(value || '');
    }

    // Dev portal uses height (in pixels) but the rad-textarea uses rows so convert height to rows
    public getRowsFromPixelHeight(): number {
        // Average line height in pixels is about 19.2px for monospace fonts
        if (this.height < 19.2) {
            return 1;
        }
        return Math.floor(this.height / 19.2);
    }

}